import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import {contextMixin} from "@/context/context";
import apiContext from "@/context/apiContext";
import alertContext from "@/context/alertContext";

// @ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDVm-0K32cuFk3WbyfgOLAn9CnMcDAuNBs',
    libraries: 'places'
  },
  installComponents: true
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mixins: [
    contextMixin,
    apiContext,
    alertContext
  ],
  render: h => h(App)
}).$mount('#app')
